import { Workbook } from 'exceljs';
import { addAoaSheet, downloadWorkbook } from './excelWorkbook';

type CampaignRow = {
  cafe_name: string;
  title: string;
  status: string;
  duration_days: number;
  budget_total_jod: number;
  orders_count: number;
  total_revenue: number;
};

type OfferRow = CampaignRow & { offer_tier?: string };

type Summary = {
  campaign_budget_total_jod: number;
  offer_budget_total_jod: number;
  campaign_count: number;
  offer_count: number;
};

export function downloadMarketingSpendExcel(
  filename: string,
  summary: Summary,
  campaigns: CampaignRow[],
  offers: OfferRow[],
  includeCafe: boolean
) {
  const campaignSheetRows: (string | number)[][] = [
    ['Marketing spend summary'],
    ['Campaign budget total (JOD)', summary.campaign_budget_total_jod.toFixed(2)],
    ['Campaign count', summary.campaign_count],
    [],
    ['Campaign spend'],
    includeCafe
      ? ['Café', 'Name', 'Status', 'Days', 'Budget (JOD)', 'Orders', 'Revenue (JOD)']
      : ['Name', 'Status', 'Days', 'Budget (JOD)', 'Orders', 'Revenue (JOD)'],
  ];

  if (campaigns.length === 0) {
    campaignSheetRows.push(['No campaigns in this period.']);
  } else {
    campaigns.forEach((r) => {
      const row = includeCafe
        ? [
            r.cafe_name,
            r.title,
            r.status,
            r.duration_days,
            r.budget_total_jod.toFixed(2),
            r.orders_count,
            r.total_revenue.toFixed(2),
          ]
        : [
            r.title,
            r.status,
            r.duration_days,
            r.budget_total_jod.toFixed(2),
            r.orders_count,
            r.total_revenue.toFixed(2),
          ];
      campaignSheetRows.push(row);
    });
  }

  const offerSheetRows: (string | number)[][] = [
    ['Offer spend summary'],
    ['Offer budget total (JOD)', summary.offer_budget_total_jod.toFixed(2)],
    ['Offer count', summary.offer_count],
    [],
    ['Offer spend'],
    includeCafe
      ? ['Café', 'Name', 'Tier', 'Status', 'Budget (JOD)', 'Orders', 'Revenue (JOD)']
      : ['Name', 'Tier', 'Status', 'Budget (JOD)', 'Orders', 'Revenue (JOD)'],
  ];

  if (offers.length === 0) {
    offerSheetRows.push(['No offers in this period.']);
  } else {
    offers.forEach((r) => {
      const row = includeCafe
        ? [
            r.cafe_name,
            r.title,
            r.offer_tier || 'basic',
            r.status,
            r.budget_total_jod.toFixed(2),
            r.orders_count,
            r.total_revenue.toFixed(2),
          ]
        : [
            r.title,
            r.offer_tier || 'basic',
            r.status,
            r.budget_total_jod.toFixed(2),
            r.orders_count,
            r.total_revenue.toFixed(2),
          ];
      offerSheetRows.push(row);
    });
  }

  const wb = new Workbook();
  addAoaSheet(wb, 'Campaigns', campaignSheetRows);
  addAoaSheet(wb, 'Offers', offerSheetRows);
  void downloadWorkbook(wb, filename);
}
